module.exports = function() {
  return new Worker(__webpack_public_path__ + "65c52363f1b34e8205b4.worker.js");
};